import React from 'react';
import { X, Trophy, Medal } from 'lucide-react';
import { getRyanFieldColor } from '../constants/ryanFieldVisuals';
import type { RyanProgressSubdeck } from './RyanFieldProgressHero';
import './RyanDomainRankingModal.css';

interface RyanDomainRankingModalProps {
  isOpen: boolean;
  onClose: () => void;
  colorId: string;
  ranked: RyanProgressSubdeck[];
  mode?: 'flashcards' | 'apostila';
}

const RyanDomainRankingModal: React.FC<RyanDomainRankingModalProps> = ({ isOpen, onClose, colorId, ranked, mode = 'flashcards' }) => {
  if (!isOpen) return null;
  const color = getRyanFieldColor(colorId);
  const isApostilaMode = mode === 'apostila';

  return (
    <div className="rdrm-overlay" onClick={onClose}>
      <div className="rdrm-modal" style={{ background: color }} onClick={e => e.stopPropagation()}>
        <div className="rdrm-header">
          <h3>{isApostilaMode ? 'Ranking de leitura' : 'Ranking de domínio'}</h3>
          <button className="rdrm-close-btn" onClick={onClose}>
            <X size={16} />
          </button>
        </div>

        <div className="rdrm-list">
          {ranked.length === 0 && (
            <p className="rdrm-empty">
              {isApostilaMode ? 'Nenhuma apostila nesta aba ainda.' : 'Nenhum deck de flashcards nesta aba ainda.'}
            </p>
          )}
          {ranked.map((s, i) => {
            const studied = !!s.lastReviewedAt;
            const pct = s.masteryPercentage ?? 0;
            const rankClass = i === 0 ? ' rdrm-item--gold' : i === 1 ? ' rdrm-item--silver' : i === 2 ? ' rdrm-item--bronze' : '';
            return (
              <div key={s._id} className={`rdrm-item${rankClass}`}>
                <span className="rdrm-pos">
                  {i === 0 ? <Trophy size={13} /> : i === 1 || i === 2 ? <Medal size={13} /> : i + 1}
                </span>
                <span className="rdrm-name">{s.name}</span>
                <span className={`rdrm-pct${studied ? '' : ' rdrm-pct--dash'}`}>
                  {studied ? `${pct}%` : '—'}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default RyanDomainRankingModal;
